import { B, BadgeDot, badgeStyle, type Tint } from "../design/tokens";
import type { MessageStatus } from "../api/client";

const MAP: Record<MessageStatus, { c: Tint; label: string }> = {
  parsed: { c: B.tints.mint, label: "Parsed" },
  skipped: { c: B.tints.sand, label: "Skipped" },
  pending: { c: B.tints.sky, label: "Waiting" },
  processing: { c: B.tints.butter, label: "Parsing…" },
  error: { c: B.tints.rose, label: "Error" },
};

export default function MessageStatusPill({ status }: { status: MessageStatus | string }) {
  const m = MAP[status as MessageStatus] ?? MAP.pending;
  return (
    <span style={badgeStyle(m.c)}>
      <BadgeDot c={m.c} />
      {m.label}
    </span>
  );
}
